<script>
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'
import { get } from 'lodash'

export default {
  extends: BaseWidgetForm,
  data() {
    return {
      arrayFields: ['header_texts'],
      initialValues: {
        header_texts: [
          { text_kind_en: 'Customer' },
          { text_kind_en: 'Project' },
          { text_kind_en: 'Deliverables' },
          { text_kind_en: 'Project Duration' },
          { text_kind_en: 'Teams' }
        ]
      }
    }
  },
  computed: {
    tabsFieldsSchema() {
      return [
        {
          label: 'Ogólne',
          fields: [
            ...this.getCommonFields(),
            new fields.Input({
              label: 'Tekst wstępny',
              modelPath: [this, 'form', 'pre_text'],
              multilingual: true,
              placeholder: 'PROJECT'
            }),
            new fields.WYSIWYG({
              label: 'Tekst',
              modelPath: [this, 'form', 'text'],
              multilingual: true,
              required: true
            }),
            new fields.Image({
              label: 'Grafika',
              modelPath: [this, 'form', 'image'],
              multilingual: true,
              required: true
            }),
            new fields.Input({
              label: 'Pierwsza linia nagłówka',
              modelPath: [this, 'form', 'header'],
              multilingual: true,
              required: true
            }),
            new fields.Input({
              label: 'Druga linia nagłówka',
              modelPath: [this, 'form', 'second_header'],
              multilingual: true
            }),
            new fields.Header({
              type: 'h4',
              text: 'Tabela nagłówka'
            }),
            new fields.Input({
              label: 'Tytuł menu bocznego',
              modelPath: [this, 'form', 'sided_menu_title'],
              multilingual: true
            }),
            new fields.Formset({
              modelPath: [this, 'form', 'header_texts'],
              disableRemovingItem: true,
              disableAddingItem: true,
              items: this.form.header_texts.map((item, i) => {
                return {
                  headerLabel: get(item, ['text_kind_en']),
                  fields: [
                    new fields.Input({
                      label: 'Tytuł',
                      modelPath: [this, 'form', 'header_texts', i, 'text_kind'],
                      multilingual: true,
                      required: true,
                      disabled: true
                    }),
                    new fields.WYSIWYG({
                      label: 'Treść',
                      type: 'textarea',
                      modelPath: [this, 'form', 'header_texts', i, 'text'],
                      multilingual: true
                    }),
                    new fields.Switch({
                      label: 'Ukryj element',
                      modelPath: [this, 'form', 'header_texts', i, 'is_hidden']
                    })
                  ]
                }
              })
            })
          ]
        }
      ]
    }
  }
}
</script>
